import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ABOUT } from './../../Data/Data';

export class About extends Component {
    render() {
        return (
            <div id="about" className="jumbotron shadow sec-width mx-auto bg-color-grey">
                <div className="mx-3 antic">
                    <h1 className="heading-font bg-color-heading rounded pl-5">About</h1>

                    <div className="bg-color-white rounded p-3">

                        <p className="body-font">{ABOUT}</p>
                        <p className="body-font">We work at the intersection of law and technology companies, saving organizations time and money. Our holistic approach seeks out ways to simplify workflows and optimize organizational processes from the inside out by identifying opportunities to redesign, streamline, and improve processes so you can provide consistent, fast, and affordable legal solutions to more clients.
</p>
                        <p className='body-font'>Our multi-prong approach is effective because it focuses on continuous improvement by looking at organizations from all angles, including:</p>
                        <ul className='body-font'>
                            <li>People (e.g. internal resource optimization) </li>
                            <li>Process (e.g. process assessment and workflow redesign)</li>
                            <li>Technology (e.g. maximizing existing software relationships)</li>
                            <li>Strategy (e.g. metrics, data visualization, and strategic decision making)</li>
                        </ul>

                        <div className="bg-color-white img-pad">
                            <img className="img-width" src='Images/BPL_graphic_LARGER.png' />
                        </div>

                        <p className="body-font">We know that no two organizations are the same, and treat our clients as such. Our approach is as unique as our backgrounds, guaranteeing you won't get another cookie cutter, out-of-the-box solution but rather a customized plan with assistance implementing every step of the way.
</p>
                        <p className="body-font">Our team's unique and varied expertise allows us to provide your team with all of the resources you need - from marketing and operations, to data analytics and knowledge management - all brought together with hands-on legal practice experience.
</p>
                        <p className="body-font">We have insight into diverse facets of the legal community and beyond, with direct links to the Association of Legal Administrators, International Legal Technology Association, Legal Marketing Association, Society of Actuaries, and Applied Research and Knowledge (ARK) Group.</p>

                    </div>



                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(About)
